import styled, { css } from 'styled-components';
import colors, { colorWithOpacity } from '../../helpers/colors';
import fonts from '../../helpers/fonts';
import mediaQuery from '../../helpers/mediaQuery';
import spacing from '../../helpers/spacing';
import { Grid } from '../Grid';
import Icon from '../Icon';

export const GridWithMargins = styled(Grid)`
  && {
    margin-top: ${spacing(3)};
    margin-bottom: ${spacing(3)};

    ${mediaQuery.tabletPortrait`
      margin-top: ${spacing(4)};
      margin-bottom: ${spacing(4)};
    `}
  }
`;

export const StyledDropdownContainer = styled.div`
  max-width: 544px;
  height: auto;
`;

export const StyledLabelContainer = styled.div`
  display: flex;
  gap: ${spacing(2)};
  align-items: center;
`;

export const StyledLabel = styled.label`
  ${fonts.headingXSmall}
  font-weight: 500;
  margin-bottom: ${spacing(1)};
`;

export const StyledHelp = styled.p`
  ${fonts.headingXSmall}
  color: ${colors.core01};
  cursor: pointer;
  text-decoration: underline;
`;

const focusOutline = css`
  outline-style: solid;
  outline-width: 4px;
  outline-color: ${colorWithOpacity(colors.core01, 0.6)};
  outline-offset: 2px;
`;

export const StyledDropdown = styled.div<{
  isOpen?: boolean;
}>`
  ${fonts.paragraphSmall}
  width: 100%;
  max-width: 544px;
  height: 60px;
  cursor: pointer;
  border-radius: ${({ theme }) => theme.inputRadius};
  ${({ isOpen }) =>
    !isOpen
      ? css`
          border: solid 1px ${colors.neutral02};
        `
      : css`
          border: solid 2px ${colors.core01};
        `}
  padding: ${spacing(2)};
  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    font-size: 1.25rem;
  }

  &:focus,
  &:focus-visible {
    ${focusOutline}
  }
`;

export const StyledDropdownList = styled.div<{ isDropdownOpen?: boolean }>`
  margin-top: ${spacing(1)};
  width: 100%;
  max-width: 544px;
  height: auto;
  max-height: 15rem;
  overflow-y: auto;
  border: 1px solid ${colors.neutral02};
  padding: 0 ${spacing(2)};
  display: ${({ isDropdownOpen: display }) => (!display ? 'none' : 'block')};
  background-color: ${colors.neutral08};
`;

const highlightOption = css`
  background-color: ${colorWithOpacity(colors.core01, 0.1)};
  border: solid 1px ${colorWithOpacity(colors.core01, 0.6)};
`;

const activateOption = css`
  outline: solid 4px ${colorWithOpacity(colors.core01, 0.6)};
`;

export const StyledDropdownListItem = styled.li<{
  isKeyboardControlStarted?: boolean;
  isMouseOver?: boolean;
  isValuePreselected?: boolean;
  isValueSelected?: boolean;
}>`
  ${fonts.paragraphSmall}
  list-style-type: none;
  font-size: 1.25rem;
  cursor: pointer;
  padding: ${spacing(2)};
  margin: ${spacing(2)} 0;
  display: flex;

  border-radius: ${({ theme }) => theme.inputRadius};

  &:hover {
    ${({ isMouseOver, isKeyboardControlStarted }) =>
      isMouseOver && !isKeyboardControlStarted && highlightOption}
  }

  ${({ isKeyboardControlStarted, isMouseOver, isValuePreselected }) =>
    isKeyboardControlStarted && !isMouseOver && isValuePreselected && highlightOption}

  &:active {
    ${activateOption}
  }

  ${({ isValueSelected }) => isValueSelected && activateOption}
`;

export const StyledIcon = styled(Icon)``;
